import React, {useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon } from '@material-ui/core';
import { getHelpCategoriesApi, getHelpSubCategoriesApi, getAllHelpTopicsApi } from 'api/help';
import { BackdropCircular } from 'components';
import TopicsList from './TopicsList';
import TopicsForm from './TopicsForm';


const Topics = () => {
  const dispatch = useDispatch();
  const [topic, setTopic] = useState();
  const { isLoadingHelpCategories, isLoadingHelpSubCategories, isLoadingHelpTopics } = useSelector((state) => state.help);


  useEffect(() => {
    getHelpCategoriesApi({ dispatch });
    getHelpSubCategoriesApi({ dispatch });
    getAllHelpTopicsApi({ dispatch });
  }, []);

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25 my-4 ml-10 pr-10">
      {topic ?
        <TopicsForm topic={topic} setTopic={setTopic} />
        :
        <>
          <Button
            color="primary"
            variant="contained"
            onClick={() => setTopic({})}
            className="mb-8 ml-4"
          >
            <Icon className="mr-2">add</Icon>
            <span>Add New Topic</span>
          </Button>
          <TopicsList setTopic={setTopic} />
        </>
      }
      <BackdropCircular loading={isLoadingHelpSubCategories || isLoadingHelpCategories || isLoadingHelpTopics} />
    </div>
  );
};

export default Topics;
